import { userSession } from '@/lib/_utils/supabase/client';
import { StateCreator } from 'zustand';
import { User } from '@supabase/supabase-js';

export type UserStore = {
	user: User | null;
	isUserProvider: boolean;
	setUser: (user: User | null) => void;
	syncUserSession: (initialUser?: User | null) => Promise<User | null>;
	setIsHydrated: (state: boolean) => void;
	isHydrated: boolean;
};

function deriveIsUserProvider(user: User | null): boolean {
	return user?.app_metadata?.is_provider;
}

export const createUserSlice: StateCreator<UserStore> = (set) => ({
	user: null,
	isUserProvider: false,
	setUser: (user) => set({ user, isUserProvider: deriveIsUserProvider(user) }),
	isHydrated: false,
	setIsHydrated: (state) => set({ isHydrated: state }),

	syncUserSession: async (initialUser) => {
		if (initialUser !== undefined) {
			set({
				user: initialUser,
				isUserProvider: deriveIsUserProvider(initialUser),
				isHydrated: true,
			});
			return initialUser;
		}

		const session = await userSession();
		const user = session?.user ?? null;
		set({
			user,
			isUserProvider: deriveIsUserProvider(user),
			isHydrated: true,
		});
		return user;
	},
});
